import { NgModule, inject } from '@angular/core';
import { Routes, RouterModule, Router } from '@angular/router';
import { AuthGuard } from './_guards/index';
import { PagesModule } from './pages/pages.module';
import { PingComponent } from './ping/ping.component';
import { NbAuthComponent } from './framework/auth/components/auth.component';
import { LoginComponent, AuthSmagComponent } from './framework/auth/components/index';
import { localStorageService } from './_services/local-storage.service';

/**
 * Affiche le formulaire de connexion directement sur l'URL demandée (sans redirection vers /auth/login)
 * quand aucune session n'existe. Si un token legacy est passé dans l'URL (?token=...), c'est AuthGuard
 * qui le valide : on ne matche donc pas cette route.
 */
const loginRequired = () => {
  const hasLegacyToken = !!inject(Router).currentNavigation()?.extractedUrl.queryParams['token'];
  return !hasLegacyToken && localStorageService.GetJsonCurrentUserBrut(true) == null;
};

const appRoutes: Routes = [
  {
      path: 'home',
      canMatch: [loginRequired],
      component: NbAuthComponent,
      children: [{ path: '**', component: LoginComponent }]
  },
  {
    path: 'home',
    canActivate: [AuthGuard],
    loadChildren: () => PagesModule
  },
  {
      path: 'ping', component: PingComponent
  },
  {
    path: 'auth',
    component: NbAuthComponent,
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
      },
      {
            path: 'login',
            component: LoginComponent,
        },
        {
            path: 'callback',
            component: AuthSmagComponent,
        },

    ]
  },
  {
    // racine sans session : login affiché sur place (pas de redirection vers /home)
    path: '',
    pathMatch: 'full',
    canMatch: [loginRequired],
    component: NbAuthComponent,
    children: [{ path: '', component: LoginComponent }]
  },
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    // URL inconnue sans session : login affiché sur place
    path: '**',
    canMatch: [loginRequired],
    component: NbAuthComponent,
    children: [{ path: '**', component: LoginComponent }]
  },
  { path: '**', redirectTo: 'home' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, { useHash: true })
  ],
  exports: [RouterModule]
})

export class AppRoutingModule { }
